module.exports = __webpack_public_path__ + "static/img/5.2e7600c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/2/eng/5.png
// module id = G78w
// module chunks = 0